window.generatePassword = () => {
  const password = makeId()
  $('#user_password').val(password)
  $('#user_password_confirmation').val(password)
  $('.password-generated').text(password)
}
